export default __webpack_public_path__ + "static/Hazard_Suit_Gloves-bca64e29ddeaca56d3c8a618d5a3a153.png";